import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import {
  M8UsersData,
  M8PaginationParams,
  M8UserSortableField,
} from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

export const getArchiveUsers = async (
  params: M8PaginationParams<M8UserSortableField>
): Promise<M8UsersData> => {
  const response = await customFetch(
    getM8AdminURL(`getArchiveUsers?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
